export const soultip_permission= {
    required_permission:[ "view_tip"]
}